import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import { ref } from "@vue/composition-api";
export default function () {
    const currentData = ref<Array<CurrentDataPoint>>([]);
    const getCurrentData = async (
        currentId: string,
        daysBack: number
    ): Promise<Array<CurrentDataPoint>> => {
        await defineHeaderAxios();
        return Axios.get(`/api/Current/${currentId}/${daysBack}`)
            .then((result: AxiosResponse<Array<CurrentDataPoint>>) => {
                if (result.status === 200) {
                    currentData.value = result.data;
                    return result.data;
                } else return new Array<CurrentDataPoint>();
            })
            .catch((error) => {
                return new Array<CurrentDataPoint>();
            });
    };
    return {
        getCurrentData,
        currentData,
    };
}

export class CurrentDataPoint {
    amperage: number;
    isRunning: boolean;
    date: Date;
}
